/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import { generateUUID } from '../../../util';
import { Placement } from '../index';

enum Quartile {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4,
}

abstract class BaseVideoPlacement extends Placement {
  protected playerWidth: number = 0;
  protected playerHeight: number = 0;

  protected adQuartilesFiredForOpportunity = {
    FIRST: false,
    SECOND: false,
    THIRD: false,
  };
  protected adCompleteFiredForOpportunity: boolean = false;
  protected adCurrentlyPlaying: boolean = false;

  protected resetStateForNewOpportunity(): void {
    Object.keys(this.adQuartilesFiredForOpportunity).forEach((key) => {
      this.adQuartilesFiredForOpportunity[key as keyof typeof this.adQuartilesFiredForOpportunity] =
        false;
    });
    this.adCompleteFiredForOpportunity = false;
    this.adCurrentlyPlaying = false;
  }

  protected dispatchAdQuartileEvent(quartile: Quartile): void {
    if (this.adCompleteFiredForOpportunity) {
      return;
    }
    const currentOpportunity = this.currentOpportunity;
    if (currentOpportunity && this.getImpressionDeliveryId()) {
      this.dispatch('VideoAdPlaybackQuartileReached', {
        quartile: quartile,
        impressionId: this.renderedAdData?.responseIdentifier ?? generateUUID(),
        opportunityId: currentOpportunity.id,
        deliveryId: this.getImpressionDeliveryId() as string,
        advertiserId: this.renderedAdData?.advertiserId ?? undefined,
        advertiserDomains: this.renderedAdData?.advertiserDomains ?? undefined,
        lineItemId: this.renderedAdData?.lineItemId ?? undefined,
        nodalsDealId: this.renderedAdData?.nodalsDealId ?? undefined,
      });
    }
  }
}

export { BaseVideoPlacement, Quartile };
